import api from './api'

export default Vue => {
	api(Vue)
}
